// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  LeaseUploadWebhookAttachment,
  IngestLeaseDocsResult,
} from "./types";

export const params = {
  bearer: __t.string(),
  emailId: __t.string(),
  code: __t.string(),
  get attachments() {
    return __t.array(LeaseUploadWebhookAttachment);
  },
};
export const returnType = IngestLeaseDocsResult